import React from "react";
import { ReactComponent as NoResultIcon } from 'static/icons/no-result.svg';
import './NoResult.scss'

const NoResult = () => {
  return (
    <div className={"no-result"}>
      <NoResultIcon className={"no-result__icon"}/>
      <p className={"no-result__title"}>No results found</p>
      <span className={"no-result__text"}>Please update your report settings and try again</span>
    </div>
  );
};

export default NoResult;
